export const FIFTEEN_MINUTES_IDLE_TIMEOUT = 1000 * 60 * 15;
